import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { chargeUser, clearPreviosChargedUserData } from '../../../redux/charge-user/actions/chargeUser.action';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import Loader from '../loader/Loader';
import styles from './ChargeUserModal.module.css';

interface ChargeUserModalProps {
    customerId: string;
    setShowChargeModal: React.Dispatch<React.SetStateAction<boolean>>;
    userId: string;
}

const ChargeUserModal = ({ customerId, setShowChargeModal, userId }: ChargeUserModalProps) => {
    const dispatch = useDispatch<AppDispatch>();

    const loading = useSelector((state: IRootState) => state.chargeUser.loading);

    const [amount, setAmount] = useState('250');
    const [reason, setReason] = useState('');
    const [error, setError] = useState({
        amount: false,
        reason: false
    });

    const reasonRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        dispatch(clearPreviosChargedUserData());
    }, []);

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();

        if (amount && reason) {
            setError({ amount: false, reason: false });
            const chargeObj = {
                stripeCustomerId: customerId,
                amount,
                description: reason,
                userId,
            };

            dispatch(chargeUser(chargeObj, setShowChargeModal));
        } else {
            setError({ amount: !amount, reason: !reason });
        }
    };


    const onAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const regex = /^\d+(\.\d{0,2})?$/;
        if (regex.test(value) && Number(value) >= 250 && Number(value) <= 999999.99) {
            setAmount(value);
            setError({ amount: false, reason: error.reason })
        } else if (value.trim() === '') {
            setAmount('');
            setError({ amount: true, reason: error.reason })
        } else if (regex.test(value)) {
            setAmount(value)
            setError({ amount: true, reason: error.reason })
        }
    }

    return (
        <>
            {loading && <Loader />}

            <div className={styles.chargeUserWrapper}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Charge</h2>
                </div>

                <div className={styles.chargeUserForm}>
                    <form onSubmit={submitHandler}>
                        <div className={styles.formWrapper}>
                            <label>
                                Charge Amount
                                <sup className={styles.required}>*</sup>
                            </label>

                            <div className={styles.chargeAmountWrapper}>
                                <span className={styles.symbolContainer} style={{ color: 'black' }}>
                                    $
                                </span>
                                <input value={amount} name="amount" onChange={(e) => onAmountChange(e)} type="string" />
                            </div>
                            {error.amount && <span className={styles.invalidChargeData}>The charge amount must be at least $250 and no more than $999,999.99.</span>}
                        </div>

                        <div className={styles.formWrapper}>
                            <label>
                                Reason <sup className={styles.required}>*</sup>
                            </label>

                            <div className={styles.chargeReasonWrapper}>
                                <textarea
                                    ref={reasonRef}
                                    placeholder="Charge Reason"
                                    value={reason}
                                    onKeyPress={(e) => {
                                        if (e.key === ' ' && reason.length === 0) {
                                            e.preventDefault();
                                        }
                                    }}
                                    name="reason"
                                    onChange={(e) => {
                                        setReason(e.target.value);
                                        if (e.target.value) {
                                            setError({ ...error, reason: false });
                                        } else {
                                            setError({ ...error, reason: true });
                                        }
                                    }}
                                />
                            </div>
                            {error.reason && <span className={styles.invalidChargeData}>Charge reason is required</span>}
                        </div>

                        <div className={styles.formSubmit}>
                            <button className={styles.btnCharge} type="submit" disabled={(error.amount || reason.trim().length === 0)}>
                                Charge
                            </button>
                            <button onClick={() => setShowChargeModal(false)} className={styles.btnCancel} type="button">
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ChargeUserModal;
